module.exports = __webpack_public_path__ + "static/media/note-4.ac5272a6.svg";